import onenewsbig from "../images/onenewsbig.svg";
import onenewssmall from "../images/onenewssmall.svg";

const Loading = () => {
    return (
        <div className="loading">
            <img src={onenewssmall} className="smallloading" alt="" />
            <img src={onenewsbig} className="onenewsbig" alt="" />
        </div>
    );
};

export default Loading;
